
import * as _ from 'lodash';

import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { Colors, DialogActionButton, FormService, ToastService } from '@wephone-utils';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogComponentBase } from '@wephone-core-ui';
import { _tk, _ti } from '@wephone-translation';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SipPhoneConfigTemplateEntity } from '@wephone-core/model/entity/sipphone_config_template';
import { SipPhoneService } from '@wephone-common/service';
import { ConfigManager } from '@wephone-core/wephone-core.module';
import { IPhoneConfigDesc } from '@wephone-core/service/config_manager.i';


@Component({
  selector: 'app-sip-phone-config-template-edit',
  templateUrl: './sip-phone-config-template-edit.component.html',
  styleUrls: ['./sip-phone-config-template-edit.component.scss']
})
export class SipPhoneConfigTemplateEditComponent extends DialogComponentBase implements OnInit {
  dialogTitle = _tk('sipphone_config_template.title.update');
  dialogRightActions: DialogActionButton[] = [
    {
      label: _tk('public.apply'),
      action: () => {
        this.submitForm();
      },
      visible: () => {
        return this.formKeys && this.formKeys.length > 0 || false;
      },
      color: Colors.PRIMARY
    }
  ];

  form: FormGroup;
  item: SipPhoneConfigTemplateEntity;
  formKeys: string[] = [];
  formLabels: { [key: string]: string } = {};

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {
      item: SipPhoneConfigTemplateEntity
    },
    dialogRef: MatDialogRef<SipPhoneConfigTemplateEditComponent>,
    private readonly fb: FormBuilder,
    private readonly sipPhoneService: SipPhoneService,
    private readonly toast: ToastService,
    private readonly formService: FormService,
    cdr: ChangeDetectorRef
  ) {
    super(dialogRef, cdr);

    this.item = data.item;
  }

  async ngOnInit(): Promise<void> {
    super.ngOnInit();

    const formGroup = {};

    const phoneModels: Record<string, IPhoneConfigDesc> = (await ConfigManager.getInstance().getPhoneModels()) || {};
    const phoneModel = phoneModels[this.item.model];
    const phoneModelParams = phoneModel && phoneModel.params || [];

    const itemParams = this.item.params || [];
    const params = [];
    if (!_.isEmpty(phoneModelParams)) {
      for (const p of phoneModelParams) {
        const itemParam = itemParams.find(x => x.key === p.key);
        if (!itemParam) {
          params.push({ key: p.key, value: p.value });
        } else {
          params.push(itemParam);
        }
      }
    }

    for (const param of params) {
      this.formKeys.push(param.key);
      this.formLabels[param.key] = phoneModelParams.find(x => x.key === param.key)?.label || 'Undefined';
      formGroup[param.key] = [param.value, [Validators.required, Validators.maxLength(256)]];
    }

    this.form = this.fb.group(formGroup);

    this.updateDialogLayout();
  }

  async submitForm(): Promise<void> {
    try {
      if (!this.formService.formIsValid(this.form)) {
        console.error('Form invalid', this.form);
        this.form.markAllAsTouched();
  
        this.updateDialogLayout();
        throw new Error(_ti('public.message.data_invalid'));
      }

      const params = [];
      for (const key of this.formKeys) {
        const value = this.form.get(key).value;
        params.push({ key, value });
      }

      const updateValue: any = {
        id: this.data.item.id,
        params
      };

      const updateItem: SipPhoneConfigTemplateEntity = await this.sipPhoneService.updateSipPhoneConfigTemplate(updateValue);

      if (!updateItem) {
        throw new Error('An error occurs');
      }

      console.log('responsed sipPhoneConfigTemplate', updateItem);
      this.toast.showSuccess(_ti('public.message.update_success'));
      this.dismiss(updateItem, false);
    } catch (e) {
      this.formService.handleResponsedError(e, this.form);
      console.error('Save sip phone config template error', e);
      this.toast.showErrorMessage(e, _ti('public.message.update_failure'));
    } finally {
      this.updateDialogLayout();
    }
  }
}
